import { useNavigate, useParams } from "react-router-dom"

export default function EventDetails(){
    const param = useParams()
    const navigation  = useNavigate()
    function handleNav(){
        navigation(`/events/${param.id}/edit`)
        // events/:id/edit
        // /events/1
    }
    return(
        <>
      
        <button onClick={handleNav}>edit</button>
        <p>EventDetails{param.id}</p>
        </>
    )
    }